import React from 'react';
import './HomeContactForm.css';
import emailjs from 'emailjs-com';

const HomeContactForm = () => {
    const sendEmail = e =>{
        e.preventDefault();
        emailjs.sendForm('service_fky26um', 'template_mreEnan', e.target,
        'user_4eLsGpFwFZG6AS6zLrcLn')
        .then((result) => {
            alert('Message has been sent successfully.')
        }, (error) => {
          console.log('failed',error.text);
        });
        e.target.reset();
    }
    return (
        <div className="home-contact-form-main-container">
            <h2 className="home-contact-form-title">Get In Touch</h2>
            <form className="home-contact-form" onSubmit={sendEmail}>
                <div className="input-field-holder">
                    <input type="text" placeholder="Name" name="name"/>
                </div>
                <div className="input-field-holder">
                    <input type="email" placeholder="Email Address" name="email"/>
                </div>
                <div className="input-field-holder">
                    <input type="text" placeholder="Subject" name="subject"/>
                </div>
                <div className="input-field-holder">
                    <textarea id="" cols="30" rows="12" placeholder="Your message" name="message"></textarea>
                </div>
                <div className="input-field-holder">
                    <input className="btn-primary-contact" type="submit" value="Send Message" />
                </div> 
            </form>
            {/* <form ref={form} onSubmit={sendEmail}>
                <label>Name</label>
                <input type="text" name="user_name" />
                <label>Email</label>
                <input type="email" name="user_email" />
                <label>Message</label>
                <textarea name="message" />
                <input type="submit" value="Send" />
            </form> */}
        </div>
    );
};

export default HomeContactForm;